import { Spacer } from '@components/common'
import NoteSkeleton from '@components/common/Note/NoteSkeleton'
import TableRowSkeleton from '@components/common/Table/TableRowSkeleton'

const AssetGLKeysDisplayLoading: React.FC = () => {
  return (
    <>
      <TableRowSkeleton height="26px" rows={5} />
      <Spacer y="default" />
      <NoteSkeleton height="var(--scale1500)" size="large" />
    </>
  )
}

export default AssetGLKeysDisplayLoading
